import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  constructor(private socket: Socket) { }
  public getMessages = (order: string) => {
    return Observable.create((observer) => {
      this.socket.on(order, (message) => {
        observer.next(message);
      });
    });
  }
}